import { workListChanged } from 'actions/action-patient';
import { editFillDeliveryConfirmation, updateFdcStatusForPrintedOrder } from 'actions/action-tasks';
import { TaskStatus } from 'interfaces/enums/TaskStatus';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { TaskTypesEnum } from 'constants/enums';
import { IPrintLabelButton } from './types';

export const updateFdcStatus = ({
  data,
  dispatch,
  setStatus,
  setCurrentStatus,
}: IPrintLabelButton) => {
  if (data?.status_id === FillDeliveryConfirmationStatus.Dispense) {
    const { fdc_statuses, auto_update_courier } = window.FEATURES;
    const autoUpdateAndFdcStatuses = fdc_statuses && auto_update_courier;
    const statusId = autoUpdateAndFdcStatuses
      ? FillDeliveryConfirmationStatus.Shipped
      : FillDeliveryConfirmationStatus.Packed;
    const taskStatusText = autoUpdateAndFdcStatuses ? TaskStatus.Shipped : TaskStatus.Packed;
    const taskType = TaskTypesEnum.FDC.toLowerCase();

    const updatedTask = {
      id: data.id,
      taskType,
      therapy_id: data.therapy_id,
      status_id: statusId,
      task_status_text: taskStatusText,
    };

    if (dispatch) {
      dispatch(editFillDeliveryConfirmation(updatedTask));
      dispatch(updateFdcStatusForPrintedOrder(updatedTask));
      dispatch(workListChanged());
    }

    if (setStatus) {
      setStatus(taskStatusText);
    }

    if (setCurrentStatus) {
      setCurrentStatus(updatedTask.status_id);
    }
  }
};
